import axios from 'axios';
import bisstrack from './bisstrack';

const INVALID_ENV_VALUES = new Set(['', 'undefined', 'null']);

const sanitizeEnvValue = (value) => {
  if (value === undefined || value === null) return null;
  const normalized = String(value).trim();
  return INVALID_ENV_VALUES.has(normalized.toLowerCase()) ? null : normalized;
};

const normalizeBaseUrl = (value) => {
  const sanitized = sanitizeEnvValue(value);
  if (!sanitized) return null;
  return sanitized.endsWith('/') ? sanitized : `${sanitized}/`;
};

const resolveApiBaseUrl = () => {
  const candidates = [
    process.env.VUE_APP_BASE_URL,
    process.env.VUE_APP_API_URL,
  ];

  for (const candidate of candidates) {
    const normalized = normalizeBaseUrl(candidate);
    if (normalized) return normalized;
  }

  return '/api/v1/';
};

async function getEmpresaConfig() {
  try {
    const isMultitenant = String(process.env.VUE_APP_MULTITENANT_ENABLED).trim() === '1';
    const empresa = sanitizeEnvValue(process.env.VUE_APP_EMPRESA);
    const apiBaseUrl = resolveApiBaseUrl();
    const configUrl = isMultitenant
      ? `${apiBaseUrl}base/clientes/config/actual`
      : `${apiBaseUrl}base/clientes/config/${encodeURIComponent(empresa || '')}`;

    const response = await axios.get(configUrl);
    const data = response.data.data;

    // Aplanar la estructura: expandir config al nivel superior y agregar logos
    const config = {
      ...data.config,  // Expandir todas las propiedades de config (theme, features, etc.)
      logos: data.logos,  // Agregar logos del nivel superior
      empresa_cliente: data.empresa_cliente,
      plan_marca: data.plan_marca,
      nombre_comercial: data.nombre_comercial,
      descripcion: data.descripcion,
      produccion: data.produccion
    };

    document.title = config.descripcion || config.nombre_comercial || config.nombre || document.title;

    return config;
  } catch (error) {
    console.error('Error al obtener la configuración de la empresa:', error);
    return bisstrack;
  }
}

// Obtener la configuración según la empresa configurada en .env
const config = await getEmpresaConfig();

export default config;